var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsSearch1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003A5D",
    d: "M18.032 16.618l3.675 3.675a1 1 0 01-1.414 1.414l-3.675-3.675a9 9 0 111.414-1.414zM11 18a7 7 0 100-14 7 7 0 000 14z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDA2IC0yNTEpIHRyYW5zbGF0ZSgzOTAgMjM1KSB0cmFuc2xhdGUoMTYgMTYpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzAwM0E1RCIgZD0iTTE4LjAzMiAxNi42MThsMy42NzUgMy42NzVjLjM5LjM5LjM5IDEuMDI0IDAgMS40MTQtLjM5LjM5LTEuMDI0LjM5LTEuNDE0IDBsLTMuNjc1LTMuNjc1QzE1LjA3OCAxOS4yNjQgMTMuMTI1IDIwIDExIDIwYy00Ljk3IDAtOS00LjAzLTktOXM0LjAzLTkgOS05IDkgNC4wMyA5IDljMCAyLjEyNS0uNzM2IDQuMDc4LTEuOTY4IDUuNjE4ek0xMSAxOGMzLjg2NiAwIDctMy4xMzQgNy03cy0zLjEzNC03LTctNy03IDMuMTM0LTcgNyAzLjEzNCA3IDcgN3oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MDYgLTI1MSkgdHJhbnNsYXRlKDM5MCAyMzUpIHRyYW5zbGF0ZSgxNiAxNikiLz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgIconsSearch1 as ReactComponent };